import Table from '@editorjs/table'

export default class TableWithoutSanitize extends Table {
  /**
     * Allow line breaks inside table cells
     *
     * @returns {object}
     */
  static get sanitize() {
    return {
      mark: true,
      br: true,
      b: true,
      i: true,
      u: true,
      strong: true,
      h1: true,
      h2: true,
      h3: true,
      h4: true,
      h5: true,
      h6: true,
      sub: true,
      sup: true,
      span: true,
      ul: true,
      ol: true,
      li: true,
      pre: true,
      hr: true,
      a: true,
    }
  }
}